/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomCertStatusSchema
 */
export interface CustomCertStatusSchema {
    /**
     * 
     * @type {string}
     * @memberof CustomCertStatusSchema
     */
    status: CustomCertStatusSchemaStatusEnum;
}


/**
 * @export
 */
export const CustomCertStatusSchemaStatusEnum = {
    Pending: 'pending',
    Error: 'error',
    InUse: 'in use',
    Ready: 'ready',
    Continue: 'continue'
} as const;
export type CustomCertStatusSchemaStatusEnum = typeof CustomCertStatusSchemaStatusEnum[keyof typeof CustomCertStatusSchemaStatusEnum];


/**
 * Check if a given object implements the CustomCertStatusSchema interface.
 */
export function instanceOfCustomCertStatusSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function CustomCertStatusSchemaFromJSON(json: any): CustomCertStatusSchema {
    return CustomCertStatusSchemaFromJSONTyped(json, false);
}

export function CustomCertStatusSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomCertStatusSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function CustomCertStatusSchemaToJSON(value?: CustomCertStatusSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
    };
}

